import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaovazamento(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaovazamento/FIND_VAZAMENTO':
      case '@operacaovazamento/UPDATE_VAZAMENTO':
      case '@operacaovazamento/DELETE_VAZAMENTO':
      case '@operacaovazamento/STORE_VAZAMENTO':
      case '@operacaovazamento/VAZAMENTO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaovazamento/SUCCESS_REMOVE':
      case '@operacaovazamento/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaovazamento/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaovazamento;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaovazamento/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaovazamento;
        break;
      }

      case '@operacaovazamento/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
